<template>
  <a-modal title="修改" :width="600" :visible="visible" @cancel="handleCancel" :closable="false" :maskClosable="false">
    <a-form :form="form">
      <a-form-item label="回复内容">
        <robot-dialoague-input v-decorator="['content']" :nouns="nouns | StrToArr"></robot-dialoague-input>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess">完成</a-button>
    </template>
  </a-modal>
</template>

<script>
import RobotDialoagueInput from '@/views/components/RobotDialoagueInput'
import DeviceApi from '@/api/device'
export default {
  components: {
    RobotDialoagueInput
  },
  data() {
    return {
      visible: false,
      id: null,
      nouns: null,
      form: this.$form.createForm(this)
    }
  },
  filters: {
    StrToArr(str) {
      return (!str||str==""||str==null||str==" ") ? [] : str.split(',')
    }
  },
  methods: {
    show({id, content, nouns}) {
      // console.log('content==',content,id);
      // console.log('nouns==',nouns);
      this.visible = true
      this.id = id
      this.getNouns()
      setTimeout(() => {
        this.form.setFieldsValue({
          content: content
        })
      },16)
    },
    getNouns() {
      DeviceApi.getDialogueNouns({ id: this.id })
        .then(res => {
          if (res.code === 1) {
            this.nouns = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    handleCancel() {
      this.visible = false
      this.id = null
      this.nouns = null
    },
    handleSeccess() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.visible = false
          const content = values.content
          const id = this.id
          this.$emit('ok', {id,content})
        }
      })
    }
  }
}
</script>
<style lang="less">
</style>
